//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'data-ingestion-progress-bar',
  props: {
    importId: {
      type: String,
      default: null,
    },
    animated: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: 'success',
    },
    showFull: {
      type: Boolean,
      default: false,
    },
    postImport: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['currentImport', 'importProgress', 'processingProgress']),
    data() {
      return this.currentImport;
    },
    count() {
      return this.postImport ? this.processingProgress.count : this.importProgress.count;
    },
    target() {
      return this.postImport ? this.processingProgress.target : this.importProgress.target;
    },
    progressMessage() {
      if (!this.count && !this.target) {
        return 'Fetching data...';
      }

      if (this.count >= this.target) {
        return 'Sync complete';
      }
      this.$emit('tick');

      return `Importing ${this.count} of ${this.target}`;
    },
    postImportMessage() {
      if (!this.count && !this.target) {
        return 'Analysis';
      }
      if (this.count >= this.target) {
        return 'Analysis complete';
      }
      if (this.count > 0) {
        let count = this.count;
        if (count > this.target) {
          count = this.target;
        }
        return 'Analyzing...';
      }
      return 'Analysis';
    },
  },
};
